import view from './View.js';
import iconSVG from 'url:../../img/icons.svg';

class paginationView extends view {
  _parentElement = document.querySelector('.pagination');

  _generateMarkup() {
    const page = this._data.page;
    const pageMax = Math.ceil(
      this._data.result.length / this._data.resultPerPage
    );

    // page one & others exist
    if ((page === 1) & (pageMax > 1)) {
      return this._generateBtnMarkupNext(page);
    }

    // last page
    if ((page === pageMax) & (pageMax > 1)) {
      return this._generateBtnMarkupPrev(page);
    }

    //other pages
    if (page > 1 && page < pageMax) {
      return [
        this._generateBtnMarkupPrev(page),
        this._generateBtnMarkupNext(page),
      ].join('');
    }

    // page one & only
    return '';
  }

  _generateBtnMarkupPrev(page) {
    return `
      <button data-goto="${page - 1}" class="btn--inline pagination__btn--prev">
        <svg class="search__icon">
          <use href="${iconSVG}#icon-arrow-left"></use>
        </svg>
        <span>Page ${page - 1}</span>
      </button>
  `;
  }
  _generateBtnMarkupNext(page) {
    return `
      <button data-goto="${page + 1}" class="btn--inline pagination__btn--next">
        <svg class="search__icon">
          <use href="${iconSVG}#icon-arrow-right"></use>
        </svg>
        <span>Page ${page + 1}</span>
      </button>
  `;
  }
  addHandlerPagination(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;
      handler(+btn.dataset.goto);
    });
  }
}

export default new paginationView();
